export default __webpack_public_path__ + "static/media/Class_Code.d53b80c9.svg";